import { render, staticRenderFns } from "./UserDefinitionEditor.vue?vue&type=template&id=f0e8d40e&scoped=true&"
import script from "./UserDefinitionEditor.vue?vue&type=script&lang=ts&"
export * from "./UserDefinitionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e8d40e",
  null
  
)

export default component.exports